import { ReactElement, useState } from 'react';

import { PoMicroFrontend } from 'micro-frontend.react';

export const MobileQrLoginModal = ({ isModalOpen }): ReactElement => {
	const [isOpen, setIsOpen] = useState<boolean>(isModalOpen);

	return <PoMicroFrontend route='/site/mobile-qr-login' isModalOpen={isOpen} setIsModalOpen={setIsOpen} />;
};
